import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import mapKeys from 'lodash-es/mapKeys';
import { customElement, property } from 'lit/decorators.js';
import _AddOn from './_AddOn';

@customElement('ol-vector-layer')
export default class OlVectorLayer extends _AddOn {
  @property({ type: Array }) features = []; // Feature list

  @property({ type: String, attribute: 'z-index' }) zIndex;

  @property({ type: Boolean }) visible = true;

  constructor() {
    super();
    this.layer = null;
  }

  connectedCallback() {
    super.connectedCallback?.();
    this._create();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this._tear();
  }

  _create() {
    this.layer = new VectorLayer({
      zIndex: this.zIndex,
      source: new VectorSource(),
    });
    this.map.addLayer(this.layer);
    this._updateProperties();
  }

  _tear() {
    if (this.layer && this.map) {
      this.map.removeLayer(this.layer);
    }
  }

  _updateProperties() {
    if (!this.layer) return;

    // Update properties on the layer
    mapKeys(this.constructor.elementProperties, (value, key) => {
      const updateFn = `_update${key.charAt(0).toUpperCase() + key.slice(1)}`;
      if (this[updateFn]) {
        this[updateFn](this[key]);
      } else {
        this.layer.set(key, this[key]);
      }
    });
  }

  _updateFeatures(features) {
    if (this.layer?.getSource()) {
      const source = this.layer.getSource();
      source.clear();
      source.addFeatures(features);
    }
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    this._updateProperties();

    if (changedProperties.has('features')) {
      this._updateFeatures(this.features);
    }
  }
}
